import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

interface PhaseData {
  phase: any,
  date: any
}

@Component({
  selector: 'app-update-project-phase',
  templateUrl: './update-project-phase.component.html',
  styleUrls: ['./update-project-phase.component.scss']
})
export class UpdateProjectPhaseComponent implements OnInit {

  @Input() phases!: any;
  @Output() updatePhase = new EventEmitter<any>();

  updatedPhaseData: PhaseData = {
    phase: null,
    date: null
  };

  constructor() { }

  ngOnInit(): void {
  }

  onPhaseDropdownChange() {
    this.updatePhase.emit(this.updatedPhaseData);
  }

  onKickoffSelect() {
    this.updatePhase.emit(this.updatedPhaseData);    
  }

}
